import Header from '../../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../../utils/Loader';
import {Link, useParams } from 'react-router-dom';
import UpdateArticle from "./UpdateArticle";
import DeleteArticle from "./DeleteArticle";
import { toast } from 'react-toastify';

import { useShowArticleQuery,useAddArticleMutation } from "../../../Services/api";
import { useForm } from "react-hook-form";

export default function EditArticle() {
    const [articleId,setArticleId] = useState("");
    const { id } = useParams();
    const {
        data: ShowArticle,
        isLoading: isGetLoading,
    } = useShowArticleQuery({params:id});
    const notify = () => '';
    const { register, handleSubmit, formState: { errors }} = useForm();
    const [AddArticle,isLoading] = useAddArticleMutation();

    const onSubmit = (values,e) => {
        AddArticle({ data: values,param:id })
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
      if(isGetLoading) return  <Loader></Loader>
      return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Learning Outcome Article</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                        <li className="nav-item flex-fill" role="presentation">
                           <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Learning Outcome Details Article</button>
                        </li>
                        
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body table-responsive">
                                                <h5 className="card-title">Add Video </h5>
                                                <form onSubmit={handleSubmit(onSubmit)} className='table-responsive' >

                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th className='text-capitalize'>Name</th>
                                                                <th className='text-capitalize'>Link</th>
                                                                <th className='text-capitalize'>action</th>
                                                            </tr>
                                                        </thead>                            
                                                        <tbody>
                                                           <tr>
                                                                <td>
                                                                    <input type="text" {...register('title')} className="form-control" />
                                                                    <span className="text-danger">{errors.title?.message}</span>
                                                                </td>
                                                                <td>
                                                                    <input type="text" {...register('link')} className="form-control" />
                                                                     <span className="text-danger">{errors.link?.message}</span>
                                                                     <input type="hidden" {...register('lod_id')} className="form-control" value={id}/>

                                                                </td>
             
                                                                <td>
                                                                    <div className="col-sm-10">
                                                                        {isLoading.status !='pending' ?    
                                                                            <button type="submit" className="btn btn-warning w-100" >Add Article</button>
                                                                                    :
                                                                            <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                                                        }
                                                                    </div>
                                                                </td>
                                                           
                                                          
                                                            </tr> 
                                                        </tbody>
                                                </table> 
                                                </form>                       
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                        </div>
                    </div>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body table-responsive">
                                                <h5 className="card-title">Article Details</h5>
                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th className='text-capitalize'>Name</th>
                                                                <th className='text-capitalize'>Link</th>
                                                                <th className='text-capitalize'>action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            ShowArticle.data !=0 ? 
                                                            ShowArticle && ShowArticle?.data?.map((item,index) => {
                                                            return (
                                                                <tr key={item.id}>
                                                                    <th scope="row">{index+1}</th>
                                                                    <td>{item?.title}</td> 
                                                                    <td className='text-primary'><Link className='text-primary' to={item.link} target="_blank" >Link</Link></td>
                                                                     
                                                                    <td>
                                                                        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">

                                                                        <div className="btn-group" role="group">
                                                                            <button id="btnGroupDrop1" type="button" className="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            Action
                                                                            </button>
                                                                            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                                                <button className="dropdown-item"  data-bs-toggle="modal" onClick={()=>setArticleId(item.id)} data-id={item.id} data-bs-target="#fullscreenModalArticle" >
                                                                                    <div className="icon text-info">
                                                                                    <i className="bi bi-pencil-square"></i>
                                                                                    Update Article
                                                                                    </div>
                                                                                </button>
                                                                               
                                                                                <DeleteArticle id={item.id} />
                                                                            </div>
                                                                        </div>
                                                                        </div>
                                                                    </td>                                                               
                                                                </tr>                                            
                                                                )   
                                                            })
                                                            :
                                                            'data not found'  
                                                        } 
                                                        </tbody>
                                                </table>                        
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                            <UpdateArticle id={articleId}/>
                            <DeleteArticle id={articleId}/>


                        </div>
                    </div>
                </div>
               
            </div>

            </main>
          
        </div>
    );
}
